import { addDays } from 'date-fns';
import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row, Stack } from 'react-bootstrap';
import { SimpleButton } from '../../../../../components/buttons/SimpleButton';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { formatDate } from '../../../../../utils/dateUtils';
import { StepProps } from './AddEditInvoice';

export const InvoiceForm = ({ touched, errors, values, setFieldValue, readOnly }: StepProps) => {
  return (
    <>
      <Row>
        <Col xs={12}>
          <FormStepHeader title="Invoice Details" showRequiredLegend={!readOnly} />
        </Col>
      </Row>
      <Row>
        <Col
          xs={12}
          lg={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="name"
          >
            <FormLabel required>Invoice Name</FormLabel>
            <Field
              name="name"
              type="text"
              as={Form.Control}
              isInvalid={touched.name && !!errors.name}
              aria-required
            />
            <ErrorMessage name="name">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="po_number"
          >
            <FormLabel>PO Number</FormLabel>
            <Field
              name="po_number"
              type="text"
              as={Form.Control}
              isInvalid={touched.po_number && !!errors.po_number}
            />
            <ErrorMessage name="po_number">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="issue_on"
          >
            <FormLabel required>Issue On</FormLabel>
            <Field
              name="issue_on"
              type="date"
              as={Form.Control}
              isInvalid={touched.issue_on && !!errors.issue_on}
              aria-required
            />
            <ErrorMessage name="issue_on">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="due_on"
          >
            <FormLabel required>Due On</FormLabel>
            <Field
              name="due_on"
              type="date"
              as={Form.Control}
              isInvalid={touched.due_on && !!errors.due_on}
              aria-required
            />
            <ErrorMessage name="due_on">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Stack
            direction="horizontal"
            gap={2}
          >
            <SimpleButton
              variant="primary"
              height={36}
              disabled={!values?.issue_on}
              onClick={() =>
                values?.issue_on
                  ? setFieldValue!(
                      'due_on',
                      formatDate(addDays(new Date(values?.issue_on), 15), 'yyyy-MM-dd')
                    )
                  : {}
              }
            >
              Net 15
            </SimpleButton>
            <SimpleButton
              variant="primary"
              height={36}
              disabled={!values?.issue_on}
              onClick={() =>
                values?.issue_on
                  ? setFieldValue!(
                      'due_on',
                      formatDate(addDays(new Date(values?.issue_on), 30), 'yyyy-MM-dd')
                    )
                  : {}
              }
            >
              Net 30
            </SimpleButton>
          </Stack>
        </Col>
      </Row>
    </>
  );
};
